import i18n from '@/libs/i18n/index'
import store from '@/store'
import useEntityCrud from '@/composable/useEntityCrud'

import useErrorManager from '@/composable/useErrorManager'
import { ref } from '@vue/composition-api'

export default function UserSignUpCheck() {
  function convertResource(resource) {
    return {
      ...resource,
      from: resource.from,
      to: resource.to,
    }
  }

  const MODULE_NAME = 'userscheck-signup'
  const ENDPOINT = 'users/check-signup'
  const MODULE_NAME1 = 'checkSignup-export'
  const ENDPOINT1 = 'users/check-signup-export'
  const entity = useEntityCrud(MODULE_NAME, ENDPOINT, convertResource)
  const entity1 = useEntityCrud(MODULE_NAME1, ENDPOINT1, convertResource)
  const errorManager = useErrorManager()
  const isSubmit = ref(false)
  const form = ref({})
  const result = ref(null)
  const result1 = ref(null)
  const loading = ref(false)
  function exportUserData(data) {
    entity1.itemLoading.value = true
    store.dispatch('crud/pExcle', { data, endpoint: ENDPOINT1 }).then(response => {
      const blob = new Blob([response.data], {
        type: 'text/xlsx; charset=utf-8',
      })
      const newBody = document.getElementById('dl-box')
      newBody.querySelectorAll('*').forEach(el => {
        if (el.tagName.toLowerCase() === 'a') {
          el.remove()
        }
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `SignUpReport_${new Date().getTime()}.xlsx`
      const linkText = document.createTextNode('دانلود فایل اکسل')
      link.appendChild(linkText)
      link.title = 'فایل اکسل'
      link.className = 'mr-1 mt-2 newALink'
      newBody.appendChild(link)
      result1.value = window.URL.createObjectURL(blob)
      loading.value = false
      isSubmit.value = false
      return result1.value
    })
      .catch(err => {
        useErrorManager(err)
      })
      .finally(() => {
        entity1.itemLoading.value = false
        const assignmentResult = false
        isSubmit.value = assignmentResult
        return assignmentResult
      })
  }

  const tableColumns = [
    { key: 'fullName', label: i18n.t('users.fullName'), icon: 'UserIcon' },
    { key: 'phoneNumber', label: i18n.t('users.phoneNumber'), icon: 'SmartphoneIcon' },
    { key: 'countryPhoneCode', label: i18n.t('users.countryCode') },
    { key: 'isVerifiedPhoneNumber', label: i18n.t('users.verifiedStatus'), icon: 'PocketIcon' },
    {
      key: 'createdAt', label: i18n.t('general.createdAt'), sortable: false, type: 'dateTime',
    },

  ]

  const fetchUserSignUp = data => {
    loading.value = true
    isSubmit.value = true
    entity.itemLoading.value = true
    exportUserData(data)
    store.dispatch('crud/add', { data, endpoint: ENDPOINT }).then(response => {
      result.value = response.data

      return response.data
    })
      .catch(err => {
        useErrorManager(err)
      })
      .finally(() => {
        const assignmentResult = false
        entity.itemLoading.value = assignmentResult; return assignmentResult
      })
  }

  const fetchList = () => {
    const data = result.value
    return {
      data: data.users,
      total: data.count,
    }
  }
  return {
    ...entity,
    convertResource,
    errorManager,
    fetchUserSignUp,
    exportUserData,
    result,
    result1,
    isSubmit,
    loading,
    form,
    tableColumns,
    fetchList,
  }
}
